import { render, staticRenderFns } from "./AppTooltip.vue?vue&type=template&id=2a70d3da&scoped=true"
import script from "./AppTooltip.vue?vue&type=script&lang=js"
export * from "./AppTooltip.vue?vue&type=script&lang=js"
import style0 from "./AppTooltip.vue?vue&type=style&index=0&id=2a70d3da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a70d3da",
  null
  
)

export default component.exports